<div class="content animated fadeInUp delay-2s" fxLayout="column" fxLayoutAlign="start start">
          <!-- <mat-card  class="cardBac animated fadeInUp delay-2s">
            <mat-card-header>
              <mat-card-title>
                {{datoPublic.labelTitle[idiomaActual]}}
              </mat-card-title>
            </mat-card-header>
            <mat-card-content style="width:100%important">
              <div class="" fxLayout="row" fxLayoutAlign="space-evenly center"  fxLayout.xs="column" fxLayout.sm="column">
                <ng-container *ngFor="let videos of datoPublic.contenido">
                  <div class="" fxLayout="column">
                    <span class="titleVideo">{{videos.labelTitle[idiomaActual]}}</span>
                    <video width="320" height="240" onmouseover="this.play()" onmouseout="this.pause()" class="ifma" style="background:black">
                      <source [src]="videos.properties[idiomaActual].url" class="ifma">
                      </video>
                      <span class="desriptionVideo">{{videos.properties[idiomaActual].description}}</span>
                    </div>
                  </ng-container>
                </div>
              </mat-card-content>
            </mat-card> -->
              <h3 class="titleCard">{{datoPublic.labelTitle[idiomaActual]}}</h3>
              <div class="" style="margin-left:10px;width:100%;overflow-x: scroll;" fxLayout.xs="column" fxLayout.sm="column">
                <div fxLayout="row" fxLayoutAlign="start start" fxLayout.xs="column" fxFlex="25" fxLayout.sm="column" style="margin-left:10px;width:100%;margin-bottom: 10px;" *ngFor="let videos of datoPublic.contenido" >
                  <div class="card" fxLayout="column" fxLayoutAlign="start center" >
                    <div class="divVideo" fxLayout="column" fxLayoutAlign="start center" >
                      <h2 class="name">{{videos.labelTitle[idiomaActual]}}</h2>
                    </div>
                    <div class="card-content" fxLayout="column" fxLayoutAlign="start center">
                      <video width="280" height="190" onmouseover="this.play()" onmouseout="this.pause()" class="ifma" style="background:black">
                        <source [src]="videos.properties[idiomaActual].url" class="ifma">
                        </video>
                        <p class="description">{{videos.properties[idiomaActual].description}}</p>
                      </div>
                    </div>
                </div>
              </div>
</div>
